import * as THREE from 'three';

import React, { useEffect, useState, useCallback } from 'react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

import SideStyle from '../style/sideStyle';
import Param from '../store/param';
import Control from '../store/control';
import { AddIcon } from './formUtil';
import { toast } from 'react-toastify';

import * as helptext from './helptext';

const FormCompressScan = () => {
  const SetCameraFront  = Control.Get("SetCameraFront");

  const style      = SideStyle();
  const align   = Param.Get('align');
  const baseshape   = Param.Get('baseshape');
  const compress   = Param.Get('compress');
  const setParam   = Param.Get('setParam');
  const setControl = Control.Get('setControl');
  const meshLeg    = Control.Get('meshLeg');

  const [showAdvance, setShowAdvance] = useState(false);
  
  useEffect(() => {
    SetCameraFront();
    toast('Ajust the compression, and go to [Modifying].');
  }, [])
  

  const handleValue = (e) => {
    setParam(s => {s.compress[e.target.name] = Number(e.target.value)});
  };

  const handleValueS = (e) => {
    setParam(s => {s.compress[e.target.name][s.compress.line_no] = Number(e.target.value)});
  };

  const handleValueCompress = (e) => {
    setParam(s => {s.compress[e.target.name][s.compress.line_no] = Number(e.target.value)});
    var mm = compress.manualCircumference[compress.line_no] * (e.target.value / 100 - 1);
    mm = Math.round(mm * 10) / 10;
    setParam(s => {s.compress.compressionMm[s.compress.line_no] = mm});
  };

  const handleCheckboxChange = (e) => {
    console.log(compress.manualOrScan[compress.line_no])
    setParam(s => {s.compress[e.target.name][s.compress.line_no] = e.target.checked});
  };

  const IndividualSetting0 = () => {
    const objects = [];

    for (var i = 1; i < compress.line_count; i++) {
      objects.push(
        (compress.line_no == i) && 
        <>
          <TextField
            key={i+'c'}
            id="filled-number"
            name='compression'
            label="Compression individual"
            type="number"
            defaultValue={Math.round(compress.compression[compress.line_no] * 10) / 10}
            fullWidth
            onBlur={handleValueS}
            InputProps={{
              endAdornment: 
              <AddIcon 
                unit='%'
                title='Compression Individual'
                helptext={helptext.compressionIndividual}
                imgSrc='./static/bk/img/compressionIndividual0.png'
                imgSrc1='./static/bk/img/compressionIndividual1.png'
              />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant="standard"
            inputProps={{
              style: {
                color: "white",
                textAlign: "left"
              }, 
              min:80,
              max:120,
              step:1
            }}
          />
          <TextField
            key={i+'s'}
            id="filled-number"
            name='smoothness'
            label="Smoothness"
            type="number"
            defaultValue={compress.smoothness[compress.line_no]}
            fullWidth
            onBlur={handleValueS}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant="standard"
            inputProps={{
              style: {
                color: "white",
                textAlign: "left"
              }, 
              min:1, 
              max:10,
              step:1
            }}
          />
        </>
      )
    }

    return objects
  }

  const IndividualSetting1 = () => {
    const objects = [];

    for (var i = compress.line_count - 3; i < compress.line_count - 2 + 1; i++) {
      objects.push(
        ((i === compress.line_no))
        && <>
          {/* manual or scan checkbox */}
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={compress.manualOrScan[compress.line_no]}
                  onChange={handleCheckboxChange}
                  name="manualOrScan"
                  color="primary"
                />
              }
              label="Manual measurement based"
            />
          </Grid>
        </>
      )

      objects.push(
        ((i === compress.line_no) && compress.manualOrScan[compress.line_no] === true)
        && <>
          {/* manual circumference */}
          <TextField
            id='filled-number'
            name='manualCircumference'
            label='Manual circumference'
            type='number'
            defaultValue={compress.manualCircumference[compress.line_no]}
            fullWidth
            onBlur={handleValueS}
            onKeyDown={e => {if (e.key === 'Enter') handleValueS(e);}}
            InputProps={{
              endAdornment: 
              <AddIcon 
                unit='mm' 
                helptext={helptext.circumferenceIndividual}
                title='Circumference'
                // imgSrc='./static/ak/img/circumferenceIndividual.png'
              />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant="standard"
            inputProps={{
              style: {
                color: "white",
                textAlign: "left"
              }, 
              min:10,
              max: 1000,
              step:1
              }
            }
          />
  
          {/* tween factor */}
          <TextField
            id='filled-number'
            name='tweenFactor'
            label={'Tween factor'}
            type='number'
            defaultValue={compress.tweenFactor[compress.line_no]}
            fullWidth
            onBlur={handleValueS}
            onKeyDown={e => {if (e.key === 'Enter') handleValueS(e);}}
            InputProps={{
              endAdornment: <AddIcon unit='' helptext='Tween factor, from 0 to 1, 0 is close to circle'/>,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant="standard"
            inputProps={{
              style: {
                color: "white",
                textAlign: "left"
              }, 
              min:0,
              max: 1,
              step:0.1
            }}
          />
        </>
      )
    }

    return objects;
  }

  const nCrossSection = Math.floor((align.stumpLength+align.stumpLengthAdjust) / align.interval)

  return (
    <div className={style.outside}>
      {/* Whole Setting */}
      <Grid container direction='column' justifyContent ='flex-start' alignItems='center'>
        <Grid item xs={12} className={style.subcategory}>Whole Setting</Grid>
      </Grid>
      <Grid container spacing={1} alignItems="center" justifyContent="center">
        <TextField
          id="filled-number"
          name='initialAbductionAngle'
          label="Initial abduction angle"
          type="number"
          defaultValue={compress.initialAbductionAngle}
          fullWidth
          onBlur={handleValue}
          onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
          InputProps={{
            endAdornment: 
            <AddIcon 
              unit='°'
              helptext={helptext.initialAbductionAngle}
              title='Initial abduction angle'
              // imgSrc='./static/ak/img/initialAdductionAngle.png'
            />,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant="standard"
          inputProps={{
            style: {
              color: "white",
              textAlign: "left"
            }, 
            min:-50, 
            max:50,
            step:1
          }}
        />

        <TextField
          id="filled-number"
          name='initialFlexionAngle'
          label="Initial flexion angle"
          type="number"
          defaultValue={compress.initialFlexionAngle}
          fullWidth
          onBlur={handleValue}
          onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
          InputProps={{
            endAdornment: 
            <AddIcon 
              unit='°'
              helptext={helptext.initialFlexionAngle}
              title='Initial flexion angle'
              // imgSrc='./static/ak/img/initialFlexionAngle.png'
            />,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant="standard"
          inputProps={{
            style: {
              color: "white",
              textAlign: "left"
            }, 
            min:-50,
            max:50,
            step:1
          }}
        />
      </Grid>
      

      {/* Individual Setting */}
      <Grid container direction='column' justifyContent ='flex-start' alignItems='center'>
        <Grid item xs={12} className={style.subcategory}>Individual Setting</Grid>
      </Grid>
      <Grid container spacing={1} alignItems='center' justifyContent="center">
        <TextField
          id="filled-number"
          name='line_no'
          label="Line No."
          type="number"
          defaultValue={compress.line_no}
          fullWidth
          onChange={handleValue}
          onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant="standard"
          inputProps={{ 
            style: {
              color: "white",
              textAlign: "left"
            }, 
            min:0,
            max:compress.line_count - 1,
            step:1
          }}
        />

        {IndividualSetting0()}
        {IndividualSetting1()}
      </Grid>
      
      <button className={style.buttonShowHide} onClick={() => setShowAdvance(prev => !prev)}>SHOW/HIDE Advance settings</button>
      {showAdvance && <div>
        <TextField
          id="filled-number"
          name='intervalAk'
          label="Interval"
          type="number"
          defaultValue={compress.intervalAk}
          fullWidth
          onBlur={handleValue}
          onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
          InputProps={{
            //https://codesandbox.io/s/69554151-how-to-change-material-ui-textfield-inputadornment-background-color-b8kqn?file=/demo.js
            //https://stackoverflow.com/questions/56811449/how-to-style-adornment-in-mui-textfield 
            endAdornment: <AddIcon unit="mm" helptext="Interval of cross sections"/>,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant="standard"
          inputProps={{
            style: {
              color: "white",
              textAlign: "left"
            }, 
            min:20, 
            max:100,
            step:1
          }}
        />

        <TextField
          id="filled-number"
          name='compressionWhole'
          label="Compression"
          type="number"
          defaultValue={compress.compressionWhole}
          fullWidth
          onBlur={handleValue}
          onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
          InputProps={{
            endAdornment: <AddIcon unit="%" helptext="Socket compression rate. It is depending on interfaces"/>,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant="standard"
          inputProps={{
            style: {
              color: "white",
              textAlign: "left"
            }, 
            min:80, 
            max:120,
            step:1
          }}
        />
      </div>}
      

      {/* Buttons */}
      {/*
      <Grid container spacing={1} alignItems='center'>
        <Grid item xs={6}>
          <Button className={style.button} onClick={onCreateSocket}>Create Socket</Button>
        </Grid>
        <Grid item xs={6}>
          <Button className={style.button} onClick={onClear} disabled={getDisabled(2)}>Clear Socket</Button>
        </Grid>
      </Grid>
      */}
    </div>
  );
}
export default FormCompressScan;